import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createNivelesSchema = yup.object({
  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),
});
